import { axiosInstance } from ".."



const removeCheckListItem = async (checkItemID,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(
          `/internal/pm/removeCheckItem/${checkItemID}`,data
                )
                .then((res) => {
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
  }
  
  export default removeCheckListItem;